export default "/static/assets/pql.7e9cbe3bae68e75b82d2d1fed86e14c4.svg";